import { useContext } from 'react';
import { assertNonNull } from '../../queues/utils/assert-non-null';
import {
    ContextMenuReadContext,
    ContextMenuReadContextValue,
    ContextMenuWriteContext,
    ContextMenuWriteContextValue,
} from './context-menu-state-context';

export function useContextMenuStateRead(): ContextMenuReadContextValue | undefined {
    return useContext(ContextMenuReadContext);
}

export function useContextMenuStateWrite(): ContextMenuWriteContextValue {
    const value = useContext(ContextMenuWriteContext);
    assertNonNull(value, 'Unexpectedly did not find context menu write state');
    return value;
}
